<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
     <div class="row justify-content-center">
   	   
   	   		<!-- start -->
   	   	  <div class="col-xl-6">
   	  	   <card  >
   	  	   
   	  	    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(change_password)">
            
				
                  <base-input alternative
                  			  label="Current Password"
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              name="current password"
                              :rules="{required: true, min: 6}"
                              v-model="model.current_password">
                  </base-input>
  

                  <base-input alternative
                  			 label="New Password"
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              name="new password"
                              :vid=model.new_password
                              :rules="{required: true, min: 6}"
                              v-model="model.new_password">
                  </base-input>
                  
                  
                   <base-input alternative
                   			  label="Confirm New Password"
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="Confirm password"
                              type="password"
                              name="passwords"
                              :rules="{required: true, confirmed:model.new_password}"
                              v-model="model.c_password">
                  </base-input>
       
           
                  <div class="text-center">
                    <button  class="btn btn-primary mt-4" native-type="submit">Change Password</button>
                  </div>
                </form>
              </validation-observer>
			  
			</card>
		 </div>
 			<!-- end -->
 			
 			
 			
 			
 			
 
 
    	</div>
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  
    },
    data() {
      return {
     	 model:{
     	 	current_password:'',
     	 	new_password:'',
     	 	c_password: ''
     	 },
	
      };
    },
    methods: {
      change_password() {
  			swal.showLoading();
  			const vm = this;
		  	let uri = this.$base_url+'/api/v1/c/change_password';
			 ApiService.post(uri, this.model).then(response => {
			 
			  	if(response.data.success == 1){
			 		this.model.current_password = '';
			 		this.model.new_password = '';
			 		this.model.c_password = '';
			 		 
					 swal.fire({
							title: `Success`,
							text: 'Your password has been changed successfully. Please login with your new password.',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-success',
							icon: 'success'
						  }).then(function(){
						  	
						  	
						  	vm.$router.push( '/logout');
						  
						  
						  });
					
  				}
  				else{
  					
  					swal.fire({
							title: `Oops`,
							text: response.data.error,
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
  				
  					
  				}//end if-else
			}) 
      }
    },
    mounted() {

      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














